// Small moments of motion for the modern look (clothing and gift stores, fashion.css): a product photo flying into the
// cart when it is added, and a burst of confetti when a gift order is placed. Nothing moves for shoppers who ask for
// reduced motion, or on the other store types.

const calm = () => typeof window === "undefined" || window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const modern = () => Boolean(document.querySelector(".theme-fashion"));

// Where the shopper last pressed: the photo flies from there
let lastPress = null;
if (typeof window !== "undefined") {
    window.addEventListener("pointerdown", (event) => { lastPress = { x: event.clientX, y: event.clientY, at: Date.now() }; }, { passive: true, capture: true });
}

// A copy of the product photo shrinks and arcs into the cart icon, which then bounces
export function flyToCart(img) {
    if (calm() || !modern() || !img) return;
    const target = document.querySelector(".cart-button");
    if (!target || !lastPress || Date.now() - lastPress.at > 1500) return;
    const to = target.getBoundingClientRect();
    const fly = document.createElement("img");
    fly.src = img;
    fly.alt = "";
    fly.className = "flyToCart";
    fly.style.left = `${lastPress.x - 32}px`;
    fly.style.top = `${lastPress.y - 32}px`;
    fly.style.setProperty("--dx", `${to.left + to.width / 2 - lastPress.x}px`);
    fly.style.setProperty("--dy", `${to.top + to.height / 2 - lastPress.y}px`);
    document.body.appendChild(fly);
    fly.addEventListener("animationend", () => {
        fly.remove();
        target.classList.remove("isBumped");
        void target.offsetWidth; // restart the bounce
        target.classList.add("isBumped");
    });
}

const COLORS = ["#f7c948", "#f08a24", "#e75480", "#b5179e", "#4cc9f0", "#43aa8b"];

// A burst of paper pieces from the top of the screen that fall and fade (about 2.5 seconds)
export function celebrate(pieces = 70) {
    if (calm() || !modern()) return;
    const layer = document.createElement("div");
    layer.className = "confettiLayer";
    layer.setAttribute("aria-hidden", "true");
    for (let i = 0; i < pieces; i += 1) {
        const bit = document.createElement("i");
        bit.style.left = `${Math.random() * 100}%`;
        bit.style.background = COLORS[i % COLORS.length];
        bit.style.setProperty("--drift", `${(Math.random() - 0.5) * 220}px`);
        bit.style.setProperty("--spin", `${(Math.random() - 0.5) * 1080}deg`);
        bit.style.animationDelay = `${Math.random() * 0.5}s`;
        bit.style.animationDuration = `${1.8 + Math.random() * 1.2}s`;
        if (i % 3 === 0) bit.style.borderRadius = "50%";
        layer.appendChild(bit);
    }
    document.body.appendChild(layer);
    window.setTimeout(() => layer.remove(), 3600);
}
